import { render, staticRenderFns } from "./SectionVerticals.vue?vue&type=template&id=df6cff48&"
import script from "./SectionVerticals.vue?vue&type=script&lang=js&"
export * from "./SectionVerticals.vue?vue&type=script&lang=js&"
import style0 from "./SectionVerticals.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports